<div class="ticket-documentations">
  <div class="add-button-wrapper">
    <span class="docs-count">{{ documentations().length }} documentação(ões)</span>
    @if (canWrite) {
      <p-button
        icon="pi pi-plus"
        label="Nova Documentação"
        size="small"
        (click)="openNewDocumentation()"
        [disabled]="loading()" />
    }
  </div>

  @if (loading() && documentations().length === 0) {
    <div class="loading-state">
      <p-skeleton height="40px" styleClass="mb-2" />
      <p-skeleton height="40px" styleClass="mb-2" />
      <p-skeleton height="40px" />
    </div>
  }

  @if (!loading() && documentations().length === 0) {
    <div class="empty-state">
      <i class="pi pi-file"></i>
      <p>Nenhuma documentação cadastrada</p>
    </div>
  }

  @if (!loading() && documentations().length > 0) {
    <div class="docs-list">
      @for (doc of documentations(); track doc.id) {
        <div class="doc-item">
          <div class="doc-info">
            <div class="doc-title-row">
              <span class="doc-title">{{ doc.title }}</span>
              <div class="doc-badges">
                <p-tag
                  [value]="getCategoryLabel(doc.category || '')"
                  [severity]="getCategorySeverity(doc.category || '')"
                  size="small" />
                <p-tag
                  [value]="getVisibilityLabel(doc.visibility || '')"
                  [severity]="getVisibilitySeverity(doc.visibility || '')"
                  size="small" />
                @if (doc.version) {
                  <p-tag [value]="'v' + doc.version" severity="secondary" size="small" />
                }
              </div>
            </div>
            @if (doc.description) {
              <div class="doc-meta">
                <small class="text-muted">{{ doc.description }}</small>
              </div>
            }
          </div>
          <div class="doc-actions">
            <p-button
              icon="pi pi-eye"
              [text]="true"
              [rounded]="true"
              size="small"
              pTooltip="Visualizar"
              tooltipPosition="top"
              (click)="viewDocumentation(doc)" />
            @if (canWrite) {
              <p-button
                icon="pi pi-pencil"
                [text]="true"
                [rounded]="true"
                size="small"
                severity="secondary"
                pTooltip="Editar"
                tooltipPosition="top"
                (click)="editDocumentation(doc)" />
              <p-button
                icon="pi pi-trash"
                [text]="true"
                [rounded]="true"
                size="small"
                severity="danger"
                pTooltip="Deletar"
                tooltipPosition="top"
                (click)="deleteDocumentation(doc)" />
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<teo-wiki-documentation-form
  #documentationForm
  (onSave)="onDocumentationSaved()"></teo-wiki-documentation-form>
